'use strict';

/* globals define, RELATIVE_PATH, $, socket, window, document, navigator */

define('surveyViewer', [
	RELATIVE_PATH + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js'
], function (Vue) {
	var SurveyViewer = {};

	SurveyViewer.init = function (survey, translations) {
		initVueApp({
			surveyId: survey.surveyId,
			questions: survey.questions,
			isCompleted: survey.submittedAnswers,
			askedQuestions: 0,
			answers: [],
			translations: translations
		});
	};

	function initVueApp(initData) {
		new Vue({
			el: '#survey-viewer',
			data: {
				initData: initData
			},
			methods: {
				reset: function () {
					this.initData.isCompleted = false; 
					this.initData.askedQuestions = 1; 
				}
			}
		});
	}

	return SurveyViewer;
});
